import { normalizeModelModality, type ModelModality } from '@/services/model-capabilities'

/**
 * Resolves model modality using backend-provided values only.
 * No longer infers modality from provider type or model ID.
 *
 * @param primaryModality - Primary modality from backend
 * @param backendModality - Alternative modality field from backend
 * @returns Resolved modality or undefined if not provided by backend
 */
export const resolveModelModality = (
  primaryModality?: string,
  backendModality?: string
): ModelModality | undefined => {
  return (
    normalizeModelModality(primaryModality) ||
    normalizeModelModality(backendModality)
  )
}
